import BuildData from './BuildData';
import Footer from './footer';

export { BuildData };
export default Footer;
